import styles from "./svg.module.scss";

type Props = {
  color?: string;
};

const DistrictWeb = ({ color }: Props) => {
  if (color === "black") {
    return (
      <svg
        id="nav--logo"
        // xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 492 165.5"
      >
        <g className={styles["district-web-mask"]} mask="url(#mask)">
          <g id="logo-text">
            <path
              className="logo-text"
              d="M249.6 62.7c0 13.3-10.1 22.5-24.1 22.5h-18V40.5h18c14 0 24.1 9.1 24.1 22.2zm-11.3 0c0-6.9-5.6-12.2-12.9-12.2h-6.8v24.7h6.8c7.3 0 12.9-5.4 12.9-12.5zm25.9-22.2v44.7h-11.1V40.5h11.1zm42 13.9H295c-.6-3.4-2.6-5.7-7.4-5.7-3.9 0-6.5 1.5-6.5 4.4 0 2.6 1.8 3.7 5.4 4.4l6.3 1.3c8.2 1.7 13.5 5.1 13.5 12.8 0 8.9-7.4 14.5-18.6 14.5-10.1 0-19.1-4.8-20.2-15.9h11.2c.7 3.9 4.1 6.4 9.3 6.4 3.9 0 6.3-1.5 6.3-4 0-1.6-.9-3.2-4.7-3.9l-7.4-1.6c-8.8-1.9-13-5.9-13-13 0-8.9 7.2-14.5 17.8-14.5 7.3 0 18.1 2.7 19.2 14.8z"
              fill="#121212"
            />
            <path
              className="logo-text"
              d="M345.4 50.4h-14.3v34.8H320V50.4h-14.3v-9.9h39.6v9.9zm29.8 34.8l-8.5-13h-.1-8.4v13h-11.1V40.5h19.5c11.1 0 18.6 6.1 18.6 15.7 0 5.9-2.8 10.6-7.6 13.4l10.5 15.7h-12.9zm-16.9-22.9h8.2c4.3 0 7.6-2.4 7.6-6.1 0-3.6-3.4-5.9-7.6-5.9h-8.2v12zm41.9-21.8v44.7H389V40.5h11.2zm38.2 26.2h11.4c-1.4 11.6-10.3 19.4-22.4 19.4-13.5 0-23.7-9.7-23.7-23.2s10.2-23.2 23.7-23.2c12.2 0 21 7.8 22.4 19.4h-11.4c-1.2-5.6-5.1-9-11.1-9C420 50 415 55.4 415 62.9c0 7.4 5.1 12.8 12.4 12.8 5.9 0 9.8-3.4 11-9zm48.9-16.3H473v34.8h-11.1V50.4h-14.3v-9.9h39.6v9.9zM272.6 93.2l-14.7 45h-10.5l-9-27.4-9 27.4h-10.5l-14.7-45H216l8.4 27.8 9.5-27.8h9.2l9.5 27.8 8.4-27.8h11.6zm12.4 9.7v8.2h19.9v9.5H285v7.8h22.7v9.7h-33.8V93.2h33.8v9.7H285zm64.3 22.7c0 7.4-6 12.4-16.1 12.4h-22.5V93.2h21.2c9.7 0 15.4 4.6 15.4 11.9 0 4.1-2.3 8.4-6.2 9.8 5.5 1.2 8.2 5.9 8.2 10.7zm-27.4-23.3v9.3h8.4c4.2 0 6.5-2.1 6.5-5 0-2.8-2.2-4.3-6.5-4.3h-8.4zm16.5 21.8c0-2.8-2.3-4.3-6.4-4.3h-10.1v9h9.9c4.6 0 6.6-2.1 6.6-4.7zm14.8 8.6c0-3.2 2.7-5.7 5.9-5.7 3.3 0 6.1 2.4 6.1 5.7 0 3.4-2.8 5.8-6.1 5.8-3.2 0-5.9-2.4-5.9-5.8z"
              fill="#121212"
            />
          </g>
        </g>
        <defs>
          <mask id="mask">
            <rect x="35%" y="0" width="65%" height="100%" fill="#fff" />
          </mask>
        </defs>
        <g id="logo">
          <path
            id="logo-circle"
            d="M85.9 163.9c-44.8 0-81.2-36.4-81.2-81.2C4.7 38 41.1 1.6 85.9 1.6S167 38 167 82.8c0 44.7-36.4 81.1-81.1 81.1zm0-155.7c-41.1 0-74.5 33.4-74.5 74.5s33.4 74.5 74.5 74.5 74.5-33.4 74.5-74.5c0-41-33.5-74.5-74.5-74.5z"
            fill="#0f21d8"
          />

          <path
            id="logo-d"
            d="M117 82.8V75v-.6-.6c-.1-2.1-.4-4.2-1-6.1h0a21.73 21.73 0 0 0-14-14c-1.8-.6-3.7-.9-5.7-1h0-1-1-22.5-15.1v45.2h15.1V113h15.1 8.4c2.3 0 4.6-.4 6.7-1 2.1-.7 4-1.6 5.8-2.9.3-.2.7-.5 1-.8.7-.5 1.3-1.1 1.9-1.7l.9-.9c2-2.2 3.5-4.9 4.4-7.8h0c.6-1.9 1-4 1-6.1v-.6-.6-7.8zm-15.1-.1h0 0 0V87c0 4.1-2.3 7.7-5.7 9.6-1.5.8-3.3 1.3-5.2 1.3h-4.2-15V82.8h0V67.7h15.1H91a10.93 10.93 0 0 1 10.9 10.9v4.1z"
            fill="#121212"
          />
        </g>
      </svg>
    );
  }

  return (
    <svg
      id="nav--logo"
      // xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 492 165.5"
    >
      <g className={styles["district-web-mask"]} mask="url(#mask)">
        <g id="logo-text">
          <path
            className="logo-text"
            d="M249.6 62.7c0 13.3-10.1 22.5-24.1 22.5h-18V40.5h18c14 0 24.1 9.1 24.1 22.2zm-11.3 0c0-6.9-5.6-12.2-12.9-12.2h-6.8v24.7h6.8c7.3 0 12.9-5.4 12.9-12.5zm25.9-22.2v44.7h-11.1V40.5h11.1zm42 13.9H295c-.6-3.4-2.6-5.7-7.4-5.7-3.9 0-6.5 1.5-6.5 4.4 0 2.6 1.8 3.7 5.4 4.4l6.3 1.3c8.2 1.7 13.5 5.1 13.5 12.8 0 8.9-7.4 14.5-18.6 14.5-10.1 0-19.1-4.8-20.2-15.9h11.2c.7 3.9 4.1 6.4 9.3 6.4 3.9 0 6.3-1.5 6.3-4 0-1.6-.9-3.2-4.7-3.9l-7.4-1.6c-8.8-1.9-13-5.9-13-13 0-8.9 7.2-14.5 17.8-14.5 7.3 0 18.1 2.7 19.2 14.8z"
            fill="#fff"
          />
          <path
            className="logo-text"
            d="M345.4 50.4h-14.3v34.8H320V50.4h-14.3v-9.9h39.6v9.9zm29.8 34.8l-8.5-13h-.1-8.4v13h-11.1V40.5h19.5c11.1 0 18.6 6.1 18.6 15.7 0 5.9-2.8 10.6-7.6 13.4l10.5 15.7h-12.9zm-16.9-22.9h8.2c4.3 0 7.6-2.4 7.6-6.1 0-3.6-3.4-5.9-7.6-5.9h-8.2v12zm41.9-21.8v44.7H389V40.5h11.2zm38.2 26.2h11.4c-1.4 11.6-10.3 19.4-22.4 19.4-13.5 0-23.7-9.7-23.7-23.2s10.2-23.2 23.7-23.2c12.2 0 21 7.8 22.4 19.4h-11.4c-1.2-5.6-5.1-9-11.1-9C420 50 415 55.4 415 62.9c0 7.4 5.1 12.8 12.4 12.8 5.9 0 9.8-3.4 11-9zm48.9-16.3H473v34.8h-11.1V50.4h-14.3v-9.9h39.6v9.9zM272.6 93.2l-14.7 45h-10.5l-9-27.4-9 27.4h-10.5l-14.7-45H216l8.4 27.8 9.5-27.8h9.2l9.5 27.8 8.4-27.8h11.6zm12.4 9.7v8.2h19.9v9.5H285v7.8h22.7v9.7h-33.8V93.2h33.8v9.7H285zm64.3 22.7c0 7.4-6 12.4-16.1 12.4h-22.5V93.2h21.2c9.7 0 15.4 4.6 15.4 11.9 0 4.1-2.3 8.4-6.2 9.8 5.5 1.2 8.2 5.9 8.2 10.7zm-27.4-23.3v9.3h8.4c4.2 0 6.5-2.1 6.5-5 0-2.8-2.2-4.3-6.5-4.3h-8.4zm16.5 21.8c0-2.8-2.3-4.3-6.4-4.3h-10.1v9h9.9c4.6 0 6.6-2.1 6.6-4.7zm14.8 8.6c0-3.2 2.7-5.7 5.9-5.7 3.3 0 6.1 2.4 6.1 5.7 0 3.4-2.8 5.8-6.1 5.8-3.2 0-5.9-2.4-5.9-5.8z"
            fill="#fff"
          />
        </g>
      </g>
      <defs>
        <mask id="mask">
          <rect x="35%" y="0" width="65%" height="100%" fill="#fff" />
        </mask>
      </defs>
      <g id="logo">
        <path
          id="logo-circle"
          d="M85.9 163.9c-44.8 0-81.2-36.4-81.2-81.2C4.7 38 41.1 1.6 85.9 1.6S167 38 167 82.8c0 44.7-36.4 81.1-81.1 81.1zm0-155.7c-41.1 0-74.5 33.4-74.5 74.5s33.4 74.5 74.5 74.5 74.5-33.4 74.5-74.5c0-41-33.5-74.5-74.5-74.5z"
          fill="#fff"
        />

        <path
          id="logo-d"
          d="M117 82.8V75v-.6-.6c-.1-2.1-.4-4.2-1-6.1h0a21.73 21.73 0 0 0-14-14c-1.8-.6-3.7-.9-5.7-1h0-1-1-22.5-15.1v45.2h15.1V113h15.1 8.4c2.3 0 4.6-.4 6.7-1 2.1-.7 4-1.6 5.8-2.9.3-.2.7-.5 1-.8.7-.5 1.3-1.1 1.9-1.7l.9-.9c2-2.2 3.5-4.9 4.4-7.8h0c.6-1.9 1-4 1-6.1v-.6-.6-7.8zm-15.1-.1h0 0 0V87c0 4.1-2.3 7.7-5.7 9.6-1.5.8-3.3 1.3-5.2 1.3h-4.2-15V82.8h0V67.7h15.1H91a10.93 10.93 0 0 1 10.9 10.9v4.1z"
          fill="#fff"
        />
      </g>
    </svg>
  );
};
export default DistrictWeb;
